var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBallTotal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9853 5.44387C11.9853 6.41448 11.1985 7.20131 10.2279 7.20131C9.25729 7.20131 8.47046 6.41448 8.47046 5.44387C8.47046 4.47326 9.25729 3.68643 10.2279 3.68643C11.1985 3.68643 11.9853 4.47326 11.9853 5.44387ZM10.2279 6.15131C10.6186 6.15131 10.9353 5.83458 10.9353 5.44387C10.9353 5.05316 10.6186 4.73643 10.2279 4.73643C9.83719 4.73643 9.52046 5.05316 9.52046 5.44387C9.52046 5.83458 9.83719 6.15131 10.2279 6.15131Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.69829 2.23051C0.423454 2.13812 0.125758 2.28602 0.0333677 2.56086C-0.0590227 2.83569 0.0888785 3.13339 0.363714 3.22578C1.37702 3.56642 3.90742 5.22102 3.90742 9.27446C3.90742 9.56441 4.14247 9.79946 4.43242 9.79946C4.72237 9.79946 4.95742 9.56441 4.95742 9.27446C4.95742 8.86156 5.02775 8.24352 5.3954 7.65168C5.75478 7.07316 6.43366 6.46216 7.75935 6.11091C8.03963 6.03665 8.20663 5.74924 8.13237 5.46896C8.05811 5.18868 7.7707 5.02167 7.49042 5.09593C6.08126 5.4693 5.19532 6.12807 4.65688 6.86951C3.8811 3.96771 1.79543 2.59933 0.69829 2.23051Z",
    fill: "#A0A0A0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBallTotal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BallTotal.e686efb362e366bf0722029bd232c78c.svg";